<template>
  <component
    :is="inputComponent"
    v-on="computedListeners"
    v-bind="computedProps"
    label=""
    solo
    flat
    auto-grow
    rows="1"
    class="border-none"
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @dblclick="setCurrentTime()"
  >
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </component>
</template>
<script>
import { VTextField, VTextarea } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'

/**
 * @file DDv2用日付入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdDateBoxInside',
  extends: VTextField,
  components: {
    VTextarea
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * multiline が true のときは v-textarea を使う
     */
    multiline: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    phtext: '',
    hasFocus: false,
    invalidMessage: '',
    innerValue: ''
  }),
  created () {
  },
  mounted () {
    const dtl = controls.getInputTypeDetail(controls.InputTypes.Time)
    if (!dtl) { return }
    this.phtext = !this.readonly ? 'HH:MM' : ''
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    // どちらのコンポーネントを使うか返す computed
    inputComponent () {
      // multiline === true なら v-textarea、そうでなければ v-text-field
      return this.multiline ? 'v-textarea' : 'v-text-field'
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      if (!this.isShowClock) {
        this[controls.VALIDATE_METHOD]()
      }
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        this.innerValue = val.split(':').join('')
      }
      const elem = this.$el.querySelector('input')
      console.log('DdTimeeBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }
        /**
         * フォーカス取得
         * @event focus
         * @type {Event}
         */
        this.$emit('focus', e)
      })
    },
    complement: function () {
      const val = complements.parseTime(this.lazyValue, this.isStraddle)
      this.$set(this, 'innerValue', val)
      /**
       * 補完値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max,
        min: this.min,
        isStraddle: this.isStraddle
      }

      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.Time)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    setCurrentTime: function (overwrite) {
      if (this.innerValue === undefined || this.innerValue === '' || overwrite === 1) {
        const now = new Date()
        const hm = complements.parseTime(`${now.getHours()}:${now.getMinutes()}`)

        this.$set(this, 'innerValue', hm)
        /**
         * 補完値input
         * @event input
         * @type {Event}
         */
        this.$emit('input', hm)
        this[controls.VALIDATE_METHOD]()
      }
      this.isShowClock = false
    }
  }
}
</script>
<style scoped>
</style>
